module.exports = __webpack_public_path__ + "img/attestation_employer_do.1b08226b.png";